
import * as React from "react";

import './Radio.scss';

const RadioInput = ({ name, options, selectedValue, onChange }) => {
    return (
        <div className={'radio'}>
            {options.map((option, index) => (
                <label key={index} className={'radio-label'}>
                    <input
                        type="radio"
                        name={name}
                        value={option.value}
                        checked={selectedValue === option.value}
                        onChange={() => onChange(option.value)}
                    />
                    {option.label}
                </label>
            ))}
        </div>
    );
};

export default RadioInput;